import script from "./CollapseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapseButton.vue?vue&type=script&setup=true&lang=ts"

import "./CollapseButton.vue?vue&type=style&index=0&id=04e3034c&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e3034c"]])

export default __exports__